import validFileSize from '../libraries/valid-file-size'
import AmountFormatter from '../libraries/amount-formatter'
import nextUploader from "../libraries/next-uploader";
import Vue from 'vue'
import bankAccountIndexVue from '../components/dentals/bank-account.vue'

export default {

  common: function () {
    const script = document.createElement('script')
    script.src = "https://ajaxzip3.github.io/ajaxzip3.js"
    document.head.appendChild(script)

    document.addEventListener('DOMContentLoaded', () => {

      if(document.getElementById('current_wizard_index') != null) {
        if(document.getElementById('current_wizard_index').value == 7) {
          new Vue({
            el: '#input_bank_account',
            render: h => h(bankAccountIndexVue)
          })
        }
      }

      Array.from(document.getElementsByClassName('btn-back')).forEach(element => {
        element.addEventListener('click', () => {
          const form = document.getElementById('wizard-form')
          form.action = '/dentals/wizard/back'
          form.submit()
        })
      })

      Array.from(document.getElementsByClassName('btn-wizard-back')).forEach(element => {
        element.addEventListener('click', (event) => {
          const form = document.getElementById('wizard-form')
          const currentWizardIndexField = document.getElementById('current-wizard-index')
          currentWizardIndexField.value = event.srcElement.dataset.currentWizardIndex
          form.action = '/dentals/wizard/back'
          form.submit()
        })
      })

      Array.from(document.getElementsByTagName('input')).forEach(element => {
        if (element.type != 'text') return
        element.addEventListener('keypress', () => {
          if (event.keyCode == 13) {
            event.preventDefault()
          }
        })
      })

      Array.from(document.getElementsByClassName('zip-search-btn')).forEach(element => {
        element.addEventListener('click', () => {
          const zip_code = element.previousElementSibling
          const state = document.getElementsByName(zip_code.name.replace('[zip_code]', '[state]'))[0]
          const city = document.getElementsByName(zip_code.name.replace('[zip_code]', '[city]'))[0]
          const street = document.getElementsByName(zip_code.name.replace('[zip_code]', '[street]'))[0]
          AjaxZip3.zip2addr(zip_code, '', state.name, city.name, street.name)
        })
      })

      const uploadObjects = [
        {elementName: 'representative_auth_file', limitSizeMB: 10},
      ]

      uploadObjects.forEach(configObj => {
        Array.from(document.getElementsByClassName(configObj.elementName)).forEach(el => {
          const masterUploadCountElem = document.getElementById(configObj.elementName + "_cnt")
          nextUploader(el, el, configObj, masterUploadCountElem)
        })
      })

      Array.from(document.getElementsByClassName('corporation_self_business')).forEach(el => {
        Array.from(document.getElementsByClassName('corporation_area')).forEach(area => {
          area.style.display = el.checked == false ? "" : "none"
        })
        el.addEventListener('change', (e) => {
          Array.from(document.getElementsByClassName('corporation_area')).forEach(area => {
            area.style.display = el.checked == false ? "" : "none"
          })
        })
      })

      Array.from(document.getElementsByClassName('upload_delete')).forEach(el => {
        el.addEventListener('click', (e) => {
          // DOM構造に依存した処理はアンチパターンだが時間がないのでこの形で‥。
          el.parentNode.parentElement.getElementsByTagName('input')[0].value = true
          el.parentElement.parentElement.getElementsByTagName('img')[0].style.display = 'none'
          el.parentElement.parentElement.getElementsByClassName('actions')[0].style.display = 'none'
          el.parentElement.parentElement.previousElementSibling.style.display = 'block'
        })
      })

      // 金額にカンマを付けるライブラリをインポート
      new AmountFormatter().Run();

      // 電話番号の正規化
      const format_phone_number = (elm) => {
        elm.value = elm.value.replace(/[ー‐‑–—―−ｰ]/g, '-')
                .replace(/[０-９]/g, (s) => {
                  return String.fromCharCode(s.charCodeAt(0) - 0xFEE0);
                })
                .replace(/[^0-9-]/g, '');
      }
      const corporation_tel = document.getElementById('corporation_tel');
      if(corporation_tel != null) {
        corporation_tel.addEventListener('change', () => { format_phone_number(corporation_tel); }, false);
      }
      const representative_tel = document.getElementById('representative_tel');
      if(representative_tel != null) {
        representative_tel.addEventListener('change', () => { format_phone_number(representative_tel); }, false);
      }
      const dental_tel = document.getElementById('dental_tel');
      if(dental_tel != null) {
        dental_tel.addEventListener('change', () => { format_phone_number(dental_tel); }, false);
      }

      // 同一住所の入力補完
      const completion_addr = document.getElementById('completion_addr');
      if(completion_addr !== null) {
        const corporation_flg = document.getElementById('_storage_corporation_corporation_flg');
        const dental_zip_code  = document.getElementById('dental_zip_code');
        const dental_state = document.getElementById('dental_state');
        const dental_city = document.getElementById('dental_city');
        const dental_street = document.getElementById('dental_street');
        const dental_building = document.getElementById('dental_building');
        const dental_state_kana = document.getElementById('dental_state_kana');
        const dental_city_kana = document.getElementById('dental_city_kana');
        const dental_street_kana = document.getElementById('dental_street_kana');
        const dental_building_kana = document.getElementById('dental_building_kana');
        if(corporation_flg === null || dental_zip_code === null || dental_state === null || dental_city === null || dental_street === null || dental_building === null || dental_state_kana === null || dental_city_kana === null || dental_street_kana === null || dental_building_kana === null) {
          return;
        }
        let zip_code, state, city, street, building, state_kana, city_kana, street_kana, building_kana;
        if(corporation_flg.value === '0') {
          zip_code = document.getElementById('_storage_representative_zip_code');
          state = document.getElementById('_storage_representative_state');
          city = document.getElementById('_storage_representative_city');
          street = document.getElementById('_storage_representative_street');
          building = document.getElementById('_storage_representative_building');
          state_kana = document.getElementById('_storage_representative_state_kana');
          city_kana = document.getElementById('_storage_representative_city_kana');
          street_kana = document.getElementById('_storage_representative_street_kana');
          building_kana = document.getElementById('_storage_representative_building_kana');
        } else if(corporation_flg.value === '1') {
          zip_code = document.getElementById('_storage_corporation_zip_code');
          state = document.getElementById('_storage_corporation_state');
          city = document.getElementById('_storage_corporation_city');
          street = document.getElementById('_storage_corporation_street');
          building = document.getElementById('_storage_corporation_building');
          state_kana = document.getElementById('_storage_corporation_state_kana');
          city_kana = document.getElementById('_storage_corporation_city_kana');
          street_kana = document.getElementById('_storage_corporation_street_kana');
          building_kana = document.getElementById('_storage_corporation_building_kana');
        }
        if(zip_code === null || state === null || city === null || street === null || building === null || state_kana === null || city_kana === null || street_kana === null || building_kana === null) {
          return;
        }
        completion_addr.addEventListener('click', () => {
          dental_zip_code.value = zip_code.value;
          dental_state.value = state.value;
          dental_city.value = city.value;
          dental_street.value = street.value;
          dental_building.value = building.value;
          dental_state_kana.value = state_kana.value;
          dental_city_kana.value = city_kana.value;
          dental_street_kana.value = street_kana.value;
          dental_building_kana.value = building_kana.value;
        }, false);
      }
    })
  },
}
